import React from "react";
import Logo from "../../components/common/Logo";

function Policy() {
    return (
        <div className="min-h-screen bg-[#F4EFE8] flex flex-col overflow-x-hidden">

            {/* ================= HEADER ================= */}
            <header className="w-full">
                <div
                    className="
            max-w-[1500px]
            mx-auto
            px-4
            sm:px-6
            md:px-8
            lg:px-10
            xl:px-12
            pt-5
            sm:pt-7
            md:pt-8
          "
                >
                    {/* Logo */}
                    <div className="mb-6 sm:mb-8 md:mb-10">
                        <Logo />
                    </div>

                    {/* Page Header */}
                    <div
                        className="
              w-full
              min-h-[58px]
              sm:min-h-[64px]
              md:min-h-[70px]
              bg-[#3f35c7]
              rounded-lg
              sm:rounded-xl
              flex
              items-center
              px-4
              sm:px-6
              md:px-8
              lg:px-10
            "
                    >
                        <h1
                            className="
                text-white
                text-[20px]
                sm:text-[24px]
                md:text-[28px]
                lg:text-[32px]
                xl:text-[36px]
                font-semibold
                leading-tight
              "
                        >
                            Privacy Policy
                        </h1>
                    </div>
                </div>
            </header>

            {/* ================= MAIN ================= */}
            <main className="flex-1 w-full">

                <div
                    className="
            max-w-[1500px]
            mx-auto
            px-4
            sm:px-6
            md:px-8
            lg:px-10
            xl:px-12
            py-10
            sm:py-12
            md:py-16
            lg:py-20
          "
                >

                    {/* ================= INTRO ================= */}
                    <section className="text-center max-w-[1050px] mx-auto">

                        <h2
                            className="
                text-[#35223F]
                text-[26px]
                sm:text-[30px]
                md:text-[34px]
                lg:text-[38px]
                xl:text-[42px]
                font-bold
                leading-tight
              "
                        >
                            Privacy Policy
                        </h2>

                        <p
                            className="
                mt-4
                sm:mt-5
                md:mt-6
                text-[#7A6D79]
                text-[14px]
                sm:text-[15px]
                md:text-[17px]
                lg:text-[18px]
                xl:text-[20px]
                leading-6
                sm:leading-7
                md:leading-8
                max-w-[900px]
                mx-auto
              "
                        >
                            We respect your privacy and are committed to protecting
                            the information you share with us while using InstaED.
                        </p>

                    </section>

                    {/* ================= CONTENT ================= */}
                    <div className="max-w-[1250px] mx-auto">

                        {/* Effective Date */}
                        <div
                            className="
                flex
                justify-start
                md:justify-end
                mt-10
                sm:mt-12
                md:mt-16
                lg:mt-20
              "
                        >
                            <p
                                className="
                  text-[#202020]
                  text-[13px]
                  sm:text-[14px]
                  md:text-[16px]
                  lg:text-[17px]
                  font-semibold
                "
                            >
                                Effective date: August 1, 2021
                            </p>
                        </div>

                        {/* ================= INFORMATION COLLECTION ================= */}
                        <section className="mt-10 sm:mt-12 md:mt-16">

                            <h3
                                className="
                  text-[#202020]
                  text-[18px]
                  sm:text-[20px]
                  md:text-[22px]
                  lg:text-[24px]
                  font-bold
                  uppercase
                  tracking-wide
                  mb-4
                  sm:mb-5
                  md:mb-6
                "
                            >
                                Information We Collect
                            </h3>

                            <p
                                className="
                  text-[#2D2D2D]
                  text-[14px]
                  sm:text-[15px]
                  md:text-[16px]
                  lg:text-[17px]
                  xl:text-[18px]
                  leading-7
                  md:leading-8
                "
                            >
                                We may collect information that you provide when creating
                                an account, using our educational services, contacting
                                support, or interacting with the platform. This information
                                may include your name, contact details, account information,
                                academic information, and other information required to
                                provide our services.
                            </p>

                        </section>

                        {/* ================= USE OF INFORMATION ================= */}
                        <section className="mt-12 sm:mt-14 md:mt-18 lg:mt-20">

                            <h3
                                className="
                  text-[#202020]
                  text-[18px]
                  sm:text-[20px]
                  md:text-[22px]
                  lg:text-[24px]
                  font-bold
                  uppercase
                  tracking-wide
                  mb-4
                  sm:mb-5
                  md:mb-6
                "
                            >
                                How We Use Your Information
                            </h3>

                            <p
                                className="
                  text-[#2D2D2D]
                  text-[14px]
                  sm:text-[15px]
                  md:text-[16px]
                  lg:text-[17px]
                  xl:text-[18px]
                  leading-7
                  md:leading-8
                "
                            >
                                Information collected through the platform may be used to
                                provide and improve educational services, manage user
                                accounts, process requests, provide customer support,
                                communicate important updates, and maintain the security
                                and functionality of the platform.
                            </p>

                        </section>

                        {/* ================= DATA PROTECTION ================= */}
                        <section className="mt-12 sm:mt-14 md:mt-18 lg:mt-20">

                            <h3
                                className="
                  text-[#202020]
                  text-[18px]
                  sm:text-[20px]
                  md:text-[22px]
                  lg:text-[24px]
                  font-bold
                  uppercase
                  tracking-wide
                  mb-4
                  sm:mb-5
                  md:mb-6
                "
                            >
                                Data Protection
                            </h3>

                            <p
                                className="
                  text-[#2D2D2D]
                  text-[14px]
                  sm:text-[15px]
                  md:text-[16px]
                  lg:text-[17px]
                  xl:text-[18px]
                  leading-7
                  md:leading-8
                "
                            >
                                We take reasonable technical and organisational measures
                                to protect your personal information against unauthorised
                                access, alteration, disclosure, or destruction. However,
                                no online service can guarantee complete security of
                                information transmitted over the internet.
                            </p>

                        </section>

                        {/* ================= THIRD PARTY ================= */}
                        <section className="mt-12 sm:mt-14 md:mt-18 lg:mt-20">

                            <h3
                                className="
                  text-[#202020]
                  text-[18px]
                  sm:text-[20px]
                  md:text-[22px]
                  lg:text-[24px]
                  font-bold
                  uppercase
                  tracking-wide
                  mb-4
                  sm:mb-5
                  md:mb-6
                "
                            >
                                Third-Party Services
                            </h3>

                            <p
                                className="
                  text-[#2D2D2D]
                  text-[14px]
                  sm:text-[15px]
                  md:text-[16px]
                  lg:text-[17px]
                  xl:text-[18px]
                  leading-7
                  md:leading-8
                "
                            >
                                Some services or features may rely on third-party
                                providers. Where applicable, information may be processed
                                by these providers only for the purposes necessary to
                                deliver the requested service and in accordance with
                                applicable requirements.
                            </p>

                        </section>

                        {/* ================= POLICY UPDATES ================= */}
                        <section className="mt-12 sm:mt-14 md:mt-18 lg:mt-20 mb-12 sm:mb-16 md:mb-20">

                            <h3
                                className="
                  text-[#202020]
                  text-[18px]
                  sm:text-[20px]
                  md:text-[22px]
                  lg:text-[24px]
                  font-bold
                  uppercase
                  tracking-wide
                  mb-4
                  sm:mb-5
                  md:mb-6
                "
                            >
                                Updates to This Policy
                            </h3>

                            <p
                                className="
                  text-[#2D2D2D]
                  text-[14px]
                  sm:text-[15px]
                  md:text-[16px]
                  lg:text-[17px]
                  xl:text-[18px]
                  leading-7
                  md:leading-8
                "
                            >
                                We may update this Privacy Policy from time to time to
                                reflect changes to our services, practices, or applicable
                                requirements. Any updated version will be made available
                                on this page.
                            </p>

                        </section>

                    </div>
                </div>
            </main>

            {/* ================= FOOTER ================= */}
            <footer className="w-full border-t border-[#DDD5C8]">

                <div
                    className="
            max-w-[1500px]
            mx-auto
            px-4
            sm:px-6
            md:px-8
            lg:px-10
            xl:px-12
            py-6
            sm:py-7
            md:py-8
          "
                >

                    <div
                        className="
              flex
              flex-col
              sm:flex-row
              items-center
              justify-center
              gap-3
              sm:gap-5
              md:gap-7
              text-center
            "
                    >

                        <a
                            href="/terms-condition"
                            className="
                text-[#5144C8]
                text-[13px]
                sm:text-[14px]
                md:text-[15px]
                hover:underline
                transition
              "
                        >
                            Terms of use
                        </a>

                        <a
                            href="/policy"
                            className="
                text-[#5144C8]
                text-[13px]
                sm:text-[14px]
                md:text-[15px]
                hover:underline
                transition
              "
                        >
                            Privacy policy
                        </a>

                        <span
                            className="
                text-[#8B8190]
                text-[13px]
                sm:text-[14px]
                md:text-[15px]
              "
                        >
                            © 2026
                        </span>

                    </div>

                </div>

            </footer>

        </div>
    );
}

export default Policy;